/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_029a44da"]'><cube-float-ball name="default" :initialPosition="(defaultPos)"/></div></template>
/* styles */
/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_029a44da"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_029a44da"}
  /** script content **/
  require("./float-ball.mpx.js?isComponent&outputPath=components%2Ffloat-ball029a44da%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./float-ball.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Ffloat-ball029a44da%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_029a44da"],
    ctorType: "component",
    outputPath: "components/float-ball029a44da/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-float-ball':getComponent(require("../../../packages/mpx-cube-ui/src/components/float-ball/index.mpx?isComponent&outputPath=components%2Findexe1137352%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>